<template>
  <div class="registeruser__form__wrapper">
    <span class="registeruser__form__title">{{ $t('registryuser.title') }}</span>
    <form v-if="registerUserStatus === RegisterUserRequestStatus.WithoutStatus">
      <div class="registeruser__form__col">
        <div>
          <label>{{ $t('registryuser.firstname') }}</label>
          <FieldInput
              name="firstName"
              type="text"
              v-model="user.firstName"
          />
          <!--      <input type="text" name="firstName" v-model="firstName">-->
        </div>
        <div>
          <label>{{ $t('registryuser.lastname') }}</label>
          <FieldInput
              name="secondName"
              type="text"
              v-model="user.secondName"
          />
          <!--      <input type="text" name="secondName" v-model="secondName">-->
        </div>
        <div>
          <label>E-mail</label>
          <FieldInput
              name="email"
              type="email"
              v-model="user.email"
          />
          <!--      <input type="email" name="email" v-model="email" autocomplete="off">-->
        </div>
        <div>
          <label>{{ $t('registryuser.password') }}</label>
          <FieldInput
              name="password"
              autocomplete="new-password"
              type="password"
              v-model="user.password"
          />
          <!--      <input type="password" name="password" v-model="password" autocomplete="off">-->
        </div>
        <div>
          <label>{{ $t('registryuser.confirmpassword') }}</label>
          <FieldInput
              name="confirm_password"
              autocomplete="new-password"
              type="password"
              v-model="user.password"
          />
          <!--      <input type="password" name="passwordconf" v-model="password" autocomplete="off">-->
        </div>
      </div>
      <div class="registeruser__form__button">
        <button @click="Cancel">{{ $t('menu.cancel') }}</button>
        <button :disabled="!isValid || isRegistering" @click="RegisterUser">{{ $t('menu.register') }}</button>
        <i v-if="isRegistering" class="pi pi-spin pi-spinner"></i>
      </div>
    </form>
    <div v-if="registerUserStatus === RegisterUserRequestStatus.OK" class="registeruser__form__message">
      <p>{{ $t('registryuser.registryok') }}</p>
      <p>{{ $t('registryuser.registryok2') }}</p>
      <button @click="GoLogin">Login</button>
    </div>
    <div v-if="registerUserStatus === RegisterUserRequestStatus.UserRegistered" class="registeruser__form__message">
      <div style="display: flex; align-items: center; gap: 1rem">
        <p>{{ $t('registryuser.userregistered1') }}</p><i class="pi pi-info-circle"
                                                          v-tooltip.bottom="'INGECON SUN Monitor, INGECON SUN Planner'"></i>
      </div>
      <p>{{ $t('registryuser.userregistered2') }}</p>
      <button @click="GoLogin">Login</button>
    </div>
    <div v-if="registerUserStatus === RegisterUserRequestStatus.Error" class="registeruser__form__message">
      <span>{{ $t('registryuser.error') }}</span>
      <button @click="Retry">{{ $t('menu.retry') }}</button>
    </div>
  </div>
</template>

<script lang="ts">
import {computed, defineComponent, reactive, ref, toRef, toRefs} from "vue";
import {
  LoginUserFormStatus,
  RecoverUserPwdRequestStatus,
  RegisterUserRequestStatus,
  User,
  UserRegister
} from "@/types/User";
import {useRouter} from "vue-router";
import APIDataServices from "@/services/APIDataServices";
import ResponseData from "@/types/ResponseData";
import * as Yup from "yup";
import {useForm} from "vee-validate";
import FieldInput from "@/components/UI/FieldInput.vue";
import {useStore} from "vuex";

export default defineComponent({
  name: "RegisterUserForm",
  components: {
    FieldInput
  },
  setup() {

    const store = useStore();

    const user: User = reactive({} as User);
    const registerUserStatus = ref(RegisterUserRequestStatus.WithoutStatus);

    const GoLogin = () => {
      Cancel();
    };

    const Cancel = () => {
      store.commit("setLoginUserFormStatus", LoginUserFormStatus.Login)
    };

    const RegisterUser = (e: any) => {
      isRegistering.value = true;
      // console.log('RegisterUser. user data: ' + JSON.stringify(user));
      if (user.email && user.password) {
        APIDataServices.registerUser(user)
            .then((response: ResponseData) => {
              isRegistering.value = false;
              // console.log('registeruser response: ' + JSON.stringify(response.data));
              const registerResult = response.data as UserRegister;
              // console.log('registerResult: ' + JSON.stringify(registerResult));
              if (registerResult.eMail && registerResult.eMail === user.email) {
                registerUserStatus.value = RegisterUserRequestStatus.OK;
              }
            })
            .catch((error: any) => {
              if (error.response) {
                const errordata = error.response.data;
                if (errordata.includes('already registered')) {
                  registerUserStatus.value = RegisterUserRequestStatus.UserRegistered;
                } else {
                  registerUserStatus.value = RegisterUserRequestStatus.Error;
                }
              }
            });
      }
      e.preventDefault();
    };

    const schema = Yup.object().shape({
      firstName: Yup.string().required().max(15),
      secondName: Yup.string().required().max(15),
      email: Yup.string().email()
          .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, "validEmail")
          .required(),
      password: Yup.string().min(12)
          .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})/, "passwordnotvalid")
          .required(),
      confirm_password: Yup.string()
          .required()
          .oneOf([Yup.ref("password")], "PasswordsNotMatch"),
    }) as any;

    const {meta, values} = useForm({
      validationSchema: schema,
        initialValues: user
    });

    const isValid = computed(() => meta.value.valid);
    const isRegistering = ref(false);

    const Retry = () => {
      registerUserStatus.value = RegisterUserRequestStatus.WithoutStatus;
    };

    return {
      ...toRefs(user),
      RegisterUser,
      Retry,
      GoLogin,
      Cancel,
      user,
      isValid,
      registerUserStatus,
      RegisterUserRequestStatus,
      isRegistering
    }
  }
});
</script>

<style scoped>
.registeruser__form__title {
  font-size: 2rem;
}

.registeruser__form__wrapper {
  margin-left: auto;
  margin-right: auto;
  width: 95%;
}

.registeruser__form__col div {
  margin-top: 2rem;
  display: grid;
  grid-template-columns: repeat(3, 2fr);
  align-content: center;
  justify-content: center;
  justify-items: center;
  align-items: center;
}

.registeruser__form__col div label {
  width: 12.5rem;
  text-align: left;
}


.registeruser__form__message {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 2.5rem;
  align-items: center;
}

.registeruser__form__message button {
  font-weight: bold;
}

.registeruser__form__button {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.registeruser__form__button button {
  font-weight: bold;
}

</style>
<style>
.registeruser__form__col div input {
  width: 15rem;
  padding-left: 1rem;
}
</style>
